<div class="general-info-card">
    <div class="header-row">
        <h3>Chicks Information</h3>
    </div>

    <div class="info-list">
        <div class="info-row">
            <div class="label">Breed</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.breedName || breedName || '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Target Weight</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.targetWeight || targetWeight || '-' }}g
            </div>
        </div>
        <div class="info-row">
            <div class="label">Quantity</div>
            <div class="sep">:</div>
            <div class="value">{{ placement?.qty || qty || '-' }}</div>
        </div>
        <div class="info-row">
            <div class="label">Parent Stock Age</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.parentStockAge || parentStockAge || '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Disinfection Program</div>
            <div class="sep">:</div>
            <div class="value">
                {{
                    placement?.disInfectionProgram || disInfectionProgram || '-'
                }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Hatchery Vaccination</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.vaccineName || vaccineName || '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Litter Type</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.litterType || litterType || '-' }}
            </div>
        </div>
    </div>
</div>
